import Bowser from 'bowser';
import checkVersionSupport from '../utils/checkVersionSupport';

const supportedOSVersion = {
	ios: '9.0',
	android: '4.4.2'
};

const onelinkParams = {
	'pid': '',
	'af_dp': 'easymarkets://',
	'c': '',
	'utm_source': 'Internal',
	'utm_medium': 'easyMarkets_web',
	'utm_term': '',
	'utm_placement': '',
	'utm_content': '',
	'utm_campaign': '',
	'utm_ef_channel': 'Mobile_app',
	'utm_ef_promotion': 'No-Promotion',
	'utm_ma_token': '',
	'utm_raf_id': ''
};



export const setupCustomParams = (params = {}) => {
	const customData = {...onelinkParams, ...params};
    const DocCookies = new easymarkets.docCookies();
	const gateway = easymarkets.Parse.prototype.gateway(DocCookies.getItem('de4fe6'));
	if ('TAR' in gateway) {
		customData.c = gateway.TAR;
		customData.utm_placement = gateway.TAR;
	}

	// Affiliate Information
	customData.utm_ma_token = DocCookies.getItem('MA_TOKEN') || '';
	return customData;	
}


class Mobile {

    constructor() {
        this.supported = false;
        const browser = Bowser.getParser(window.navigator.userAgent, true);
        
        this.name = (browser.getOSName() || '').toLowerCase();
        this.version = (browser.getOSVersion() || 0);
		this.supported = false; 
		
		// Check supported versions
		if (!!~Object.keys(supportedOSVersion).indexOf(this.name)) {
			this.supported = checkVersionSupport(this.version, supportedOSVersion[this.name]);
		}

		// Check China
		if (easymarkets.geo.data.countryIsoCode === 'CN') {
			this.supported = false;
		}

    }

    isSupported() {
        return this.supported;
    }

	isIos() {
		return this.name === 'ios';
	}

	isAndroid() {
		return this.name === 'android';
	}

	isMobile() {
		return this.isIos() || this.isAndroid();
	}

}

export default Mobile;